import permissions from './permission-list'

export default [
  {
    path: '/roles',
    name: 'roles',
    component: () => import('@/views/roles/index.vue'),
    meta: {
      pageTitle: 'Daftar Role',
      resource: permissions.role,
      action: 'read',
      navActiveLink: 'roles',
      breadcrumb: [
        {
          text: 'Daftar Role',
          active: true,
        },
      ],
    },
  },
  {
    path: '/roles/create',
    name: 'roles-create',
    component: () => import('@/views/roles/create.vue'),
    meta: {
      pageTitle: 'Buat Role',
      resource: permissions.role,
      action: 'manage',
      navActiveLink: 'roles',
      breadcrumb: [
        {
          text: 'Roles',
          active: false,
          to: { path: '/roles' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/roles/:id/edit',
    name: 'roles-edit',
    component: () => import('@/views/roles/edit.vue'),
    meta: {
      pageTitle: 'Edit Roles',
      resource: permissions.role,
      action: 'manage',
      navActiveLink: 'roles',
      breadcrumb: [
        {
          text: 'Roles',
          active: false,
          to: { path: '/roles' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
